<form
  class="form"
  #cameraform="ngForm"
  (ngSubmit)="cameraform.form.valid && onSubmit()"
  novalidate
>
  <div class="row">
    <div class="col-md-12">
      <h4 class="border-bottom font-weight-bold">Camera Details</h4>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <input
            matInput
            placeholder="Camera Name"
            required
            [(ngModel)]="cameraFormValue.camera_name"
            type="text"
            name="camera_name"
            autocomplete="off"
          />
          <mat-error *ngIf=""></mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <mat-select
            placeholder="IP Type"
            required
            [(ngModel)]="cameraFormValue.camera_ip_type"
            name="camera_ip_type"
          >
            <mat-option [value]="'Private'">Private</mat-option>
            <mat-option [value]="'Public'">Public</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <input
            matInput
            placeholder="Camera IP"
            required
            [(ngModel)]="cameraFormValue.camera_ip"
            type="text"
            name="camera_ip"
            autocomplete="off"
          />
          <mat-error *ngIf=""></mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <mat-form-field class="example-full-width">
          <mat-select
            placeholder="Camera Type"
            required
            [(ngModel)]="cameraFormValue.camera_type"
            name="camera_type"
          >
            <ng-container *ngFor="let item of cameraType_list; index as i">
              <mat-option [value]="item.slug">{{ item.name }}</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div style="text-align: center">
    <button
      type="submit"
      mat-raised-button
      class="btn btn-primary"
      [disabled]="!cameraform.valid"
      color="primary"
    >
      {{ formtype ? 'Update' : 'Save' }}
    </button>
    &nbsp;&nbsp;&nbsp;
    <a
      (click)="viewCameralist()"
      mat-raised-button
      class="btn btn-light-primary btn-bold"
    >
      Cancel
    </a>
  </div>
</form>
